import { StyleSheet } from 'react-native';
import { TagSize, TagShape, TagPreset, PresetColorConfig } from './DbTag.types';

/** 预设颜色配置 */
export const PRESET_COLORS: Record<TagPreset, PresetColorConfig> = {
    default: {
        primary: '#666666',
        light: '#F5F5F5',
        text: '#666666',
    },
    primary: {
        primary: '#007AFF',
        light: '#E5F2FF',
        text: '#007AFF',
    },
    success: {
        primary: '#34C759',
        light: '#E8F8ED',
        text: '#34C759',
    },
    warning: {
        primary: '#FF9500',
        light: '#FFF4E5',
        text: '#FF9500',
    },
    danger: {
        primary: '#FF3B30',
        light: '#FFECEB',
        text: '#FF3B30',
    },
    info: {
        primary: '#5856D6',
        light: '#EEEEFF',
        text: '#5856D6',
    },
    hot: {
        primary: '#FF2442',
        light: '#FFE8EB',
        text: '#FF2442',
    },
    new: {
        primary: '#00C853',
        light: '#E5FAF0',
        text: '#00C853',
    },
    sale: {
        primary: '#FF6B6B',
        light: '#FFEFEF',
        text: '#FF6B6B',
    },
    discount: {
        primary: '#FF4757',
        light: '#FFEBEE',
        text: '#FF4757',
    },
    'free-shipping': {
        primary: '#2ED573',
        light: '#E8FAEF',
        text: '#2ED573',
    },
    guarantee: {
        primary: '#1E90FF',
        light: '#E8F4FF',
        text: '#1E90FF',
    },
    vip: {
        primary: '#FFD700',
        light: '#FFFBEB',
        text: '#B8860B',
    },
    recommend: {
        primary: '#FF6B35',
        light: '#FFF0EB',
        text: '#FF6B35',
    },
};

/** 尺寸配置 */
export const SIZE_CONFIG: Record<TagSize, {
    paddingH: number;
    paddingV: number;
    fontSize: number;
    iconSize: number;
    minHeight: number;
}> = {
    mini: {
        paddingH: 4,
        paddingV: 1,
        fontSize: 10,
        iconSize: 10,
        minHeight: 16,
    },
    small: {
        paddingH: 6,
        paddingV: 2,
        fontSize: 11,
        iconSize: 12,
        minHeight: 20,
    },
    medium: {
        paddingH: 8,
        paddingV: 4,
        fontSize: 12,
        iconSize: 14,
        minHeight: 24,
    },
    large: {
        paddingH: 12,
        paddingV: 6,
        fontSize: 14,
        iconSize: 16,
        minHeight: 32,
    },
};

/** 形状配置 */
export const SHAPE_RADIUS: Record<TagShape, number | 'full'> = {
    square: 2,
    rounded: 4,
    round: 999,
};

/** 获取形状的圆角值 */
export const getShapeRadius = (shape: TagShape, height: number): number => {
    const radius = SHAPE_RADIUS[shape];
    if (radius === 'full' || radius === 999) {
        return height / 2;
    }
    return radius;
};

/** 创建样式 */
export const createStyles = () => {
    return StyleSheet.create({
        // 基础容器
        container: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'flex-start',
        },
        // 禁用状态
        disabled: {
            opacity: 0.5,
        },
        // 文本
        text: {
            fontWeight: '500',
        },
        // 图标容器
        iconLeft: {
            marginRight: 2,
        },
        iconRight: {
            marginLeft: 2,
        },
        // 关闭按钮
        closeButton: {
            marginLeft: 4,
            padding: 2,
        },
        closeIcon: {
            opacity: 0.7,
        },
        // 标签组
        tagGroup: {
            flexDirection: 'row',
            flexWrap: 'wrap',
        },
        tagGroupNoWrap: {
            flexWrap: 'nowrap',
        },
        tagGroupAlignCenter: {
            justifyContent: 'center',
        },
        tagGroupAlignRight: {
            justifyContent: 'flex-end',
        },
    });
};
